// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"594":"about","692":"draft"}[chunkId] + "." + {"594":"aaf1a8fb","692":"8ff98ec4"}[chunkId] + ".js";
};